export default "__VITE_ASSET__f58ea8ad__"